import { render } from "./ProductSelectForm.vue?vue&type=template&id=f15a5ed8&scoped=true&ts=true"
import script from "./ProductSelectForm.vue?vue&type=script&lang=ts"
export * from "./ProductSelectForm.vue?vue&type=script&lang=ts"

import "./ProductSelectForm.vue?vue&type=style&index=0&id=f15a5ed8&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15a5ed8"]])

export default __exports__